var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5V6C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6V5C20 4.44772 19.5523 4 19 4H16C15.4477 4 15 4.44772 15 5V6H9V5C9 4.44772 8.55228 4 8 4H5C4.44772 4 4 4.44772 4 5ZM13.5303 9.46967C13.8232 9.76256 13.8232 10.2374 13.5303 10.5303L11.8107 12.25H14C14.3033 12.25 14.5768 12.4327 14.6929 12.713C14.809 12.9932 14.7448 13.3158 14.5303 13.5303L11.5303 16.5303C11.2374 16.8232 10.7626 16.8232 10.4697 16.5303C10.1768 16.2374 10.1768 15.7626 10.4697 15.4697L12.1893 13.75H10C9.69665 13.75 9.42318 13.5673 9.30709 13.287C9.191 13.0068 9.25517 12.6842 9.46967 12.4697L12.4697 9.46967C12.7626 9.17678 13.2374 9.17678 13.5303 9.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.4983ba1edc50abbfafb08b0536227f3b.svg";
export { ForwardRef as ReactComponent };